import IconClose from 'components/CruiseDetailModal/icons/IconClose';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { useContext, useEffect, useRef } from 'react';
import { FILTERS_WRAPPER } from '../../Filters/constants';
import { CruiseCardProps } from '../CruiseCard.types';
import ItineraryMap from '../ItineraryMap';
import {
	MapCruiseCardCloseButton,
	MapCruiseCardContainer,
	MapCruiseCardGridSection,
	MapCruiseCardHeader,
	MapCruiseCardName,
	MapCruiseCardNights,
} from './MapCruiseCard.styled';
import MapCruiseCardGrid from './MapCruiseCardGrid/MapCruiseCardGrid';
import { MapCruiseCardGridDisclaimer } from './MapCruiseCardGrid/MapCruiseCardGrid.styled';
import MapCruiseCardShip from './MapCruiseCardShip/MapCruiseCardShip';

function MapCruiseCard({ setActiveVariant, defaultVariant, cruise }: Pick<CruiseCardProps, 'setActiveVariant' | 'defaultVariant' | 'cruise'>) {
	const { globalization }: any = useContext(CruiseSearchContext);
	const { filtersDictionary, itineraryCardsDictionary } = globalization?.dictionaries || {};
	const { labelNightsAppender } = filtersDictionary;
	const { labelMapDisclaimer } = itineraryCardsDictionary;
	const cardContainerRef = useRef<any>(null);

	useEffect(() => {
		const stickiedFiltersHeader = document.getElementById(FILTERS_WRAPPER);

		const cardTopPosition = cardContainerRef.current.getBoundingClientRect().top + window.scrollY;
		const headerHeight = stickiedFiltersHeader ? stickiedFiltersHeader.offsetHeight : 0;
		const offsetPosition = cardTopPosition - headerHeight;

		window.scroll({ top: offsetPosition, behavior: 'smooth' });
	}, []);

	return (
		<MapCruiseCardContainer ref={cardContainerRef}>
			<MapCruiseCardCloseButton
				onClick={(e) => {
					e.stopPropagation();
					setActiveVariant(defaultVariant);
				}}
			>
				<IconClose />
			</MapCruiseCardCloseButton>
			<MapCruiseCardHeader>
				<MapCruiseCardNights>{`${cruise.itinerary.totalNights} ${labelNightsAppender}`}</MapCruiseCardNights>
				<MapCruiseCardName>{cruise.itinerary.name}</MapCruiseCardName>
				<MapCruiseCardShip shipName={cruise.itinerary.ship?.name} />
			</MapCruiseCardHeader>
			<ItineraryMap portSequence={cruise.itinerary.portSequence} />
			<MapCruiseCardGridSection>
				<MapCruiseCardGrid cruise={cruise} />
				<MapCruiseCardGridDisclaimer>{labelMapDisclaimer}</MapCruiseCardGridDisclaimer>
			</MapCruiseCardGridSection>
		</MapCruiseCardContainer>
	);
}

export default MapCruiseCard;
